var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailArrowDownDarkGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 8.7474V12.2474M11.0833 12.2474L12.25 11.0807M11.0833 12.2474L9.91667 11.0807M7.58333 11.0807H3.61667C2.96327 11.0807 2.63657 11.0807 2.38701 10.9536C2.16749 10.8417 1.98901 10.6632 1.87716 10.4437C1.75 10.1942 1.75 9.86745 1.75 9.21406V4.78073C1.75 4.12734 1.75 3.80064 1.87716 3.55107C1.98901 3.33155 2.16749 3.15307 2.38701 3.04122C2.63657 2.91406 2.96327 2.91406 3.61667 2.91406H10.3833C11.0367 2.91406 11.3635 2.91406 11.613 3.04122C11.8325 3.15307 12.011 3.33155 12.1228 3.55107C12.25 3.80064 12.25 4.12734 12.25 4.78073V6.41406M12.0206 4.81692L9.07077 6.78349C8.32236 7.28241 7.94815 7.5319 7.54367 7.6288C7.1862 7.71449 6.81357 7.71449 6.45616 7.6288C6.05168 7.5319 5.67746 7.28241 4.92902 6.78349L1.83602 4.72146",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailArrowDownDarkGray);
export default __webpack_public_path__ + "static/media/mail-arrow-down-dark-gray.5b16660172333f94fb36428890322c2b.svg";
export { ForwardRef as ReactComponent };